import { render, staticRenderFns } from "./DishModifiersModal.vue?vue&type=template&id=33b32004&"
import script from "./DishModifiersModal.vue?vue&type=script&lang=js&"
export * from "./DishModifiersModal.vue?vue&type=script&lang=js&"
import style0 from "./DishModifiersModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports